import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import LinkCTA from '../linkCTA';
import MobileOrDesktopDialog from '@/components/common/mobileOrDesktopDialog';
import Editbooking from '@/public/images/EditBooking.svg';
import ThankYou from '@/public/images/ThankYou.svg';
import CallHelpDesk from '@/assets/Icons/call-helpdesk.svg';
import Call from '@/assets/Icons/call-white-border.svg';
import useOnce from '@/hooks/useOnce';
import { viewPageAPI } from '@/analytics/middleware';
import { VIEW_PAGE_ADSC_MODIFY_BOOKING_MODAL } from '@/analytics/events';
import {
    formatBookingDetails,
    getMMVDetails,
} from '@/components/fakeDoor/utils';

type Props = {
    modalTYpe: 'MODIFY' | 'THANK_YOU' | 'NEED_HELP';
    show: boolean;
    primaryCTAHandler: () => void;
    linkHandler?: () => void;
    onClose?: () => void;
    data?: {
        booking?: any;
    };
};

const MODAL_CONFIG = {
    MODIFY: {
        heading: 'Want to make changes to your booking?',
        secondaryText: '',
        ICON: Editbooking,
        primaryCTA: 'Reschedule',
        linkCTA: 'Cancel Booking',
    },
    THANK_YOU: {
        heading: 'Thank you for your inputs, your booking is cancelled',
        secondaryText: '',
        ICON: ThankYou,
        primaryCTA: 'Okay',
        linkCTA: '',
    },
    NEED_HELP: {
        heading: 'Need help? Speak to our agent',
        secondaryText: 'Connect with us now for immediate help',
        ICON: CallHelpDesk,
        primaryCTA: (
            <>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                    }}
                >
                    <Call />
                    Schedule Callback
                </div>
            </>
        ),
        linkCTA: '',
    },
};

function ModalWithCTAAndText({
    modalTYpe,
    show,
    primaryCTAHandler,
    linkHandler,
    onClose,
    data,
}: Props) {
    const { ICON, heading, secondaryText, primaryCTA, linkCTA } =
        MODAL_CONFIG[modalTYpe];
    useOnce(() => {
        show &&
            modalTYpe === 'MODIFY' &&
            viewPageAPI({
                event_name: VIEW_PAGE_ADSC_MODIFY_BOOKING_MODAL,
                customAttributes: {
                    ...getMMVDetails(),
                    ...formatBookingDetails(data?.booking),
                },
                isFakeDoor: true,
            });
    });
    return (
        <MobileOrDesktopDialog show={show} onClose={onClose}>
            <>
                <div>
                    <ICON />
                </div>
                <div className="heading">{heading}</div>
                {secondaryText != '' && (
                    <p className="secondaryText">{secondaryText}</p>
                )}
                <div className="cta-wrapper">
                    <PrimaryButton onClick={primaryCTAHandler}>
                        {primaryCTA}
                    </PrimaryButton>
                    {linkHandler && (
                        <LinkCTA
                            text={linkCTA}
                            clickHandler={linkHandler}
                        ></LinkCTA>
                    )}
                </div>
                <style jsx>{`
                    .heading {
                        color: #121212;
                        font-size: 20px;
                        font-weight: 600;
                        line-height: 28px;
                        margin: 20px 0; /* 140% */
                    }
                    .secondaryText {
                        margin: 0;
                        margin-bottom: 20px;
                        color: #4b4b4b;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: 24px;
                    }
                    .cta-wrapper {
                        margin: 12px 0;
                    }
                `}</style>
            </>
        </MobileOrDesktopDialog>
    );
}

export default ModalWithCTAAndText;
